import { render, staticRenderFns } from "./DialogPrescription.vue?vue&type=template&id=41447334&scoped=true&"
import script from "./DialogPrescription.vue?vue&type=script&lang=js&"
export * from "./DialogPrescription.vue?vue&type=script&lang=js&"
import style0 from "./DialogPrescription.vue?vue&type=style&index=0&id=41447334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41447334",
  null
  
)

export default component.exports